export default __webpack_public_path__ + "static/media/pinduoduo.50b76975.webp";